import { getGlobalHeadersAsObject } from "../global-headers";

export type PersonEvent = {
	id: number;
	model: "Vote" | "SentInvitation" | "Connection";
	name: string;
	description: string;
	icon: string;
	timestamp: number;
	user: string;
	/** Real LinkedIn "connected on" date — Connection events only. */
	connected?: string | null;
	/** Enqueue date from the queue snapshot — SentInvitation events only. */
	enqueued?: string | null;
	/** Role group the nightly invite job queued it from — SentInvitation only;
	 *  null for invites from any other path. Mirrors core InviteTier. */
	tier?: InviteTier | null;
	/** Role of the up-vote that caused the invite — SentInvitation only. */
	assignment_name?: string | null;
};

export type InviteTier =
	| "assignments_egenkonsulter_active"
	| "assignments_egenkonsulter"
	| "assignments"
	| "assignments_same_g"
	| "assignments_active"
	| "assignments_inactive";

export const getPersonEventsById = (id: number): Promise<PersonEvent[]> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonEducationById called with invalid argument id '${id}'. Expected number`
		);
	}

	return fetch(`/api/v2/persons/${id}/events/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
